module.exports = {
  displayName: 'NOTIFICATIONS',
  description: 'Notification settings',
  sortOrder: 6,
  name: 'notifications',
  documentKey: 'notifications',
  sections: {
  },
};
